import AccountSummary from "../js/components/accountManagement/AccountSummary.react";
export default AccountSummary;
